const accepts = {
  image: "image/*",
  resume: "application/msword,application/pdf",
};



const createFileInput = (config = {}) => {
  let input = document.createElement('input');
  input.type = "file";
  input.multiple = config.multiple;
  input.accept = config.accept;
  input.className = "visually-hidden";
  
  return input;
}

const selectFiles = (config) => {
  return new Promise((resolve) => {
    let input = createFileInput(config);
    document.body.appendChild(input);

    input.onchange = (e) => {
      const files = event.target.files;
      resolve({
        files: files,
        input: input
      });
    }

    input.click();
    return input;
  });
}

const loadFile = (file) => {
  return new Promise((res, rej) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      res(e.target.result);
    };
  })
}

export { 
  accepts,
  createFileInput, 
  selectFiles,
  loadFile
};